/* =========================================================================
   Operator — theme scripts
   No dependencies, no build step.
   ========================================================================= */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};
  var settings = window.themeSettings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function trapFocus(container) {
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return function () {};
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
    return function () { container.removeEventListener('keydown', onKey); };
  }

  function lockScroll(lock) {
    document.body.classList.toggle('no-scroll', !!lock);
  }

  /* ------------------------------------------------------- mobile nav -- */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    var releaseFocus = function () {};

    function open() {
      nav.classList.add('is-open');
      lockScroll(true);
      $$('[data-mobile-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var panel = $('.rail__panel', nav) || $('.mobile-nav__panel', nav);
      if (panel) releaseFocus = trapFocus(panel);
    }
    function close() {
      nav.classList.remove('is-open');
      lockScroll(false);
      $$('[data-mobile-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      releaseFocus();
    }

    $$('[data-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.contains('is-open') ? close() : open();
      });
    });
    $$('[data-mobile-close]', nav).forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    var mq = window.matchMedia('(min-width: 1000px)');
    function syncViewport(e) {
      if (e.matches && nav.classList.contains('is-open')) close();
    }
    if (mq.addEventListener) mq.addEventListener('change', syncViewport);
    else if (mq.addListener) mq.addListener(syncViewport);

    $$('[data-submenu-toggle]', nav).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* --------------------------------------------------------- accordion -- */
  function initAccordions(root) {
    $$('[data-accordion-trigger]', root || document).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* ------------------------------------------------------------ search -- */
  function initSearch() {
    var overlay = $('[data-search-overlay]');
    if (!overlay) return;
    var input = $('[data-predictive-input]', overlay);
    var results = $('[data-predictive-results]', overlay);
    var releaseFocus = function () {};

    function open() {
      overlay.hidden = false;
      lockScroll(true);
      releaseFocus = trapFocus($('.search-overlay__panel', overlay));
    }
    function close() {
      overlay.hidden = true;
      lockScroll(false);
      releaseFocus();
    }

    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-search-close]', overlay).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    if (!input || !results || !routes.predictiveSearch) return;

    var run = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 250);

    input.addEventListener('input', run);
  }

  /* -------------------------------------------------------- cart drawer -- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  var cartDrawer = {
    el: null,
    releaseFocus: function () {},
    open: function () {
      this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      this.el.classList.add('is-open');
      lockScroll(true);
      this.releaseFocus = trapFocus($('.drawer__panel', this.el));
    },
    close: function () {
      var el = $('[data-cart-drawer]');
      if (!el) return;
      el.classList.remove('is-open');
      lockScroll(false);
      this.releaseFocus();
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var current = $('[data-cart-drawer]');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            bindCartDrawer();
            if (wasOpen || openAfter) self.open();
          }
        });
    }
  };

  function bindCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    $$('[data-drawer-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { cartDrawer.close(); });
    });
    bindCartLineActions(drawer);
  }

  function changeCartLine(key, quantity) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return cartDrawer.refresh(false);
      });
  }

  function bindCartLineActions(root) {
    $$('[data-line-remove]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        changeCartLine(btn.getAttribute('data-line-key'), 0);
      });
    });
    $$('[data-line-qty]', root).forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      input.addEventListener('change', function () {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        changeCartLine(input.getAttribute('data-line-key'), qty);
      });
    });
  }

  /* ------------------------------------------------------ add to cart -- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (settings.cartType !== 'drawer') return; // let it post normally
        e.preventDefault();
        var button = $('[data-add-to-cart]', form);
        var errorEl = $('[data-form-error]', form);
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        if (button) { button.classList.add('is-disabled'); button.disabled = true; }

        var formData = new FormData(form);
        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: formData
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorEl) {
                errorEl.textContent = (res.body && res.body.description) || strings.cartError;
                errorEl.hidden = false;
              }
              return;
            }
            return fetch(routes.cart + '.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { updateCartCount(cart.item_count); })
              .then(function () { return cartDrawer.refresh(true); });
          })
          .catch(function () {
            if (errorEl) { errorEl.textContent = strings.cartError; errorEl.hidden = false; }
          })
          .finally(function () {
            if (button) { button.classList.remove('is-disabled'); button.disabled = false; }
          });
      });
    });

    $$('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (settings.cartType !== 'drawer') return;
        e.preventDefault();
        cartDrawer.open();
      });
    });
  }

  /* --------------------------------------------------- variant picker -- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var data = null;
      var script = $('[data-variant-json]', picker);
      if (!script) return;
      try { data = JSON.parse(script.textContent); } catch (err) { return; }

      var form = picker.closest('[data-product-form]') || document.querySelector('[data-product-form]');
      var idInput = form ? $('[data-variant-id]', form) : null;
      var priceEl = $('[data-product-price]', picker.closest('[data-product-root]') || document);
      var button = form ? $('[data-add-to-cart]', form) : null;
      var selects = $$('[data-option-index]', picker);

      function update() {
        var chosen = selects.map(function (s) { return s.value; });
        var match = data.variants.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];

        if (!match) {
          if (button) { button.disabled = true; $('[data-add-to-cart-text]', button).textContent = strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
        if (button) {
          var label = $('[data-add-to-cart-text]', button);
          button.disabled = !match.available;
          if (label) label.textContent = match.available ? strings.addToCart : strings.soldOut;
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  /* -------------------------------------------------------- quantity -- */
  function initQuantity() {
    $$('[data-quantity]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var val = parseInt(input.value, 10) || min;
          input.value = Math.max(min, val + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------ media gallery -- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          var srcset = thumb.getAttribute('data-srcset') || '';
          if (main && src) {
            main.setAttribute('src', src);
            main.setAttribute('alt', alt);
            if (srcset) main.setAttribute('srcset', srcset);
          }
          $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------------------------------------------------------- reveal -- */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }


  /* -------------------------------------------------- accessible tabs -- */
  function initTabs(root) {
    $$('[data-tabs]', root || document).forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = '1';

      var tabs = $$('[role="tab"]', group);
      var panels = $$('[role="tabpanel"]', group);
      if (!tabs.length) return;

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach(function (panel, i) {
          var active = i === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        if (focus) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var last = tabs.length - 1;
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next !== null) { e.preventDefault(); select(next, true); }
        });
      });

      var initial = tabs.findIndex ? tabs.findIndex(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      }) : 0;
      select(initial > -1 ? initial : 0, false);
    });
  }

  /* -------------------------------------------------- pointer lighting -- */
  function initPointer(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    $$('[data-pointer]', root || document).forEach(function (el) {
      if (el.dataset.pointerBound) return;
      el.dataset.pointerBound = '1';

      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        el.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
        el.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
        el.classList.add('is-lit');
      });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-lit'); });
    });
  }

  /* ------------------------------------------------------------- init -- */
  function init() {
    initMobileNav();
    initAccordions();
    initSearch();
    bindCartDrawer();
    bindCartLineActions(document);
    initProductForms();
    initVariantPickers();
    initQuantity();
    initGallery();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function () {
    initAccordions();
    initProductForms();
    initVariantPickers();
    initQuantity();
    initGallery();
    initTabs();
    bindCartDrawer();
    $$('.reveal').forEach(function (i) { i.classList.add('is-visible'); });
  });
})();
